// extracted by mini-css-extract-plugin
export var container = "_o5-0";
export var dotAnimation = "_o5-2";
export var dotsLoading = "_o5-1";